import { InquiryPage } from "@/pages/Bespoke";

export default function Trade() {
    return <InquiryPage
        title="For Architects & Designers"
        eyebrow="Trade Program"
        heading="Join the Adore Trade Program"
        blurb="Preferred trade pricing, dedicated project managers, on-site lighting-plan review, and priority delivery for architecture and interior design studios. Over 400 studios currently work with us."
        inquiryType="trade"
    />;
}
